
import ReactGA from "react-ga4";
// Initialize Google Analytics
export const initGA = (trackingId) => {
    ReactGA.initialize(trackingId);
};

// Track page views
export const trackPageView = (path) => {
    ReactGA.send({ hitType: "pageview", page: path });
};

// Track events
export const trackEvent = (category, action, label) => {
    ReactGA.event({ category, action, label });
};
/**
 * Tracks when a user scrolls to a particular section.
 * @param {Object} sectionRef - React ref object for the section.
 * @param {String} sectionName - Name of the section to track.
 * @param {Number} threshold - Threshold for the IntersectionObserver.
 */
export const trackSectionView = (sectionRef, sectionName, threshold = 0.8) => {
    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                ReactGA.event({
                    category: "Section",
                    action: `Scrolled to ${sectionName} Section`,
                    label: sectionName,
                });
            }
        },
        { threshold }
    );

    if (sectionRef.current) {
        observer.observe(sectionRef.current);
    }

    return () => {
        if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
};

/**
 * Tracks button clicks.
 * @param {String} buttonName - Name of the button being tracked.
 * @param {String} pageName - The page where the button resides.
 */
export const trackButtonClick = (buttonName, pageName) => {
    ReactGA.event({
        category: "Button",
        action: `Clicked ${buttonName} Button`,
        label: pageName,
    });
};

/**
 * Tracks time spent on a section.
 * @param {Object} sectionRef - React ref object for the section.
 * @param {String} sectionName - Name of the section to track.
 */
export const trackTimeSpentOnSection = (sectionRef, sectionName) => {
    let startTime = null;
    const handleScroll = () => {
        if (sectionRef.current) {
            const rect = sectionRef.current.getBoundingClientRect();
            const isInViewport = rect.top < window.innerHeight && rect.bottom >= 0;

            if (isInViewport) {
                if (startTime === null) {
                    startTime = Date.now();
                }
            } else if (startTime !== null) {
                const duration = Date.now() - startTime;
                ReactGA.event({
                    category: "Section",
                    action: `Spent ${Math.round(duration / 1000)} seconds in ${sectionName} Section`,
                    label: sectionName,
                });
                startTime = null; // Reset startTime
            }
        }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
        window.removeEventListener("scroll", handleScroll);
        if (startTime !== null) {
            const duration = Date.now() - startTime;
            ReactGA.event({
                category: "Section",
                action: `Spent ${Math.round(duration / 1000)} seconds in ${sectionName} Section`,
                label: "Page",
            });
        }
    };
};
